<div class="flex flex-col full-grow-no-shrink-no-basis">
  <div class="modal-header flex flex-row justify-between items-center">
    <h1>Add User</h1>

    <mat-dialog-actions>
      <button class="material-icons" mat-dialog-close
              particleAnalytics
              analyticsCategory="ed-cell-editor-container"
              analyticsAction="close-btn"><i class="fa-regular fa-xmark"></i>
      </button>
    </mat-dialog-actions>

  </div>

  <mat-dialog-content class="full-grow-no-shrink-no-basis">
    <form class="flex flex-col full-grow-no-shrink-no-basis" [formGroup]="addUserForm"
          (keydown.enter)="$event.preventDefault()">
      <div class="flex flex-col flex-1-0-auto">

        <div class="flex flex-row justify-start items-start auto-flex">
          <mat-form-field appearance="outline" class="flex-1-1-100">
            <mat-label>First Name</mat-label>
            <input matInput required formControlName="firstName"
                   particleAnalytics
                   analyticsCategory="account-settings"
                   analyticsAction="password-input">
            <mat-error *ngIf="addUserFormErrors.firstName.hasOwnProperty('required')">
              First name is required.
            </mat-error>
          </mat-form-field>
        </div>

        <div class="flex flex-row justify-start items-start auto-flex">
          <mat-form-field appearance="outline" class="flex-1-1-100">
            <mat-label>Last Name</mat-label>
            <input matInput required formControlName="lastName"
                   particleAnalytics
                   analyticsCategory="account-settings"
                   analyticsAction="password-input">
            <mat-error *ngIf="addUserFormErrors.lastName.hasOwnProperty('required')">
              Last name is required.
            </mat-error>
          </mat-form-field>
        </div>

        <div class="flex flex-row justify-start items-start auto-flex">
          <mat-form-field appearance="outline" class="flex-1-1-100">
            <mat-label>Select Company</mat-label>
            <mat-select required formControlName="companyModel" [compareWith]="objectComparisonFunction">
              <mat-option *ngFor="let company of companies" [value]="company">
                {{ company.companyName?company.companyName:company.companyId }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="addUserFormErrors.companyModel.hasOwnProperty('required')">
              Company is required.
            </mat-error>
          </mat-form-field>
        </div>

        <div class="flex flex-row justify-start items-start auto-flex">
          <mat-form-field appearance="outline" class="flex-1-1-100">
            <mat-label>Designation</mat-label>
            <input matInput formControlName="designation"
                   particleAnalytics
                   analyticsCategory="account-settings"
                   analyticsAction="password-input">
          </mat-form-field>
        </div>

        <div class="flex flex-row justify-start items-start auto-flex">
          <mat-form-field appearance="outline" class="flex-1-1-100">
            <mat-label>Email Address</mat-label>
            <input matInput required formControlName="email"
                   particleAnalytics
                   analyticsCategory="account-settings"
                   analyticsAction="password-input">
            <mat-error *ngIf="addUserFormErrors.email.hasOwnProperty('required')">
              Email address is required.
            </mat-error>
            <mat-error *ngIf="addUserFormErrors.email.hasOwnProperty('pattern')">
              Email address must be valid.
            </mat-error>
          </mat-form-field>
        </div>

      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions class="modal-footer flex flex-row justify-between items-center">
    <button mat-button class="mat-flat-button orbitax-footer-button mat-button" [mat-dialog-close]="result">Cancel
    </button>
    <button mat-button (click)="onSave()" [mat-dialog-close]="result"
            class="orbitax-footer-action-button mat-button mat-flat-button mat-accent" type="button" color="accent"
            [disabled]="!addUserForm.valid" cdkFocusInitial>Save
    </button>
  </mat-dialog-actions>
</div>
